// extracted by mini-css-extract-plugin
export default {"content":"paySuccess_content__PYi7i","pay_info":"paySuccess_pay_info__ceZBI","banner":"paySuccess_banner__arpBw","title":"paySuccess_title__0v+by"};